// Directory.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Container, Button, Form, Modal } from 'react-bootstrap';

const Directory = () => {
  const [activeTab, setActiveTab] = useState('files'); 
  const [contractors, setContractors] = useState([]);
  const [packageHistory, setPackageHistory] = useState([]);
  const [emailHistory, setEmailHistory] = useState([]);
  const [conversionHistory, setConversionHistory] = useState([]);
  

  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
  
    fetchFiles();
    
    if (activeTab === 'contractors') {
      fetchContractors();
    } else if (activeTab === 'history') {
      fetchPackageHistory();
    } else if (activeTab === 'emails') {
      fetchEmailHistory();
    } else if (activeTab === 'conversions') {
      fetchConversionHistory();
    }
  }, [activeTab]);

  const fetchContractors = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/contractors-info');
      setContractors(response.data);
    } catch (error) {
      console.error('Error fetching contractors:', error);
    }
  };

  const fetchPackageHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/pac-history');
      setPackageHistory(response.data);
    } catch (error) {
      console.error('Error fetching package history:', error);
    }
  };

  const fetchEmailHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/email-history');
      setEmailHistory(response.data);
    } catch (error) {
      console.error('Error fetching email history:', error);
    }
  };

  const fetchConversionHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/conversion-history-l');
      setConversionHistory(response.data);
    } catch (error) {
      console.error('Error fetching conversion history:', error);
    }
  };

  
  const fetchFiles = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/files-list');
      setFiles(response.data);
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };


  const fetchFileContent = async (filename) => {
    try {
      const response = await axios.get(`https://bank2.daolog.net/file-content/${filename}`);
      setSelectedFile(filename);
      setFileContent(response.data.content);
      setShowEditModal(true);
    } catch (error) {
      console.error('Error fetching file content:', error);
    }
  };


  const saveFileContent = async () => {
    try {
      await axios.post('https://bank2.daolog.net/save-file', {
        filename: selectedFile,
        content: fileContent
      });
      setShowEditModal(false);
      fetchFiles();
    } catch (error) {
      console.error('Error saving file:', error);
    }
  };

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '120px auto 0',
      padding: '0 20px'
    },
    header: {
      color: '#333',
      borderBottom: '2px solid #333',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      marginBottom: '20px',
      flexWrap: 'wrap'
    },
    button: {
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      color: 'white',
      transition: 'background-color 0.3s'
    },
    card: {
      marginBottom: '20px',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    cardItem: {
      marginBottom: '10px',
      fontSize: '16px'
    },
    fileContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '20px',
      width: '100%'
    },
    fileCard: {
      marginBottom: '20px',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center' 
    },
    fileContent: {
      minHeight: '150px',
      padding: '10px',
      backgroundColor: '#f5f5f5',
      borderRadius: '5px',
      marginBottom: '10px',
      overflowY: 'auto',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      width: '100%',
      textAlign: 'center' 
    },
    fileName: {
      fontWeight: 'bold',
      marginBottom: '10px',
      textAlign: 'center' 
    },
    editButton: {
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      padding: '8px 15px',
      cursor: 'pointer'
     
    },
    modalTextarea: {
      width: '100%',
      minHeight: '300px',
      padding: '10px',
      marginBottom: '15px',
      fontFamily: 'monospace',
      textAlign: 'center' 
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    },
    buttonGroup: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      marginTop: '15px'
    }
  };

  return (
    <div style={styles.container}>
     
      <div style={styles.buttonContainer}>
    
   
        <button
          onClick={() => setActiveTab('files')}
          style={{
            ...styles.button,
            backgroundColor: '#2196F3' 
          }}
        >
          Текстові файли
        </button>
      </div>

      <Container>
      
        {}
        <div style={styles.fileContainer}>
          {files.map((file, index) => (
            <div key={index} style={styles.fileCard}>
              <div style={styles.fileContent}>
                {file.content}
              </div>
              <div style={styles.fileName}>
                <strong>Файл:</strong> B:\bot-texe\{file.name}
              </div>
              <button 
                style={styles.editButton}
                onClick={() => fetchFileContent(file.name)}
              >
                Редагувати
              </button>
            </div>
          ))}
        </div>
      </Container>

      {}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{textAlign: 'center', width: '100%'}}>Редагування файлу: {selectedFile}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={styles.modalContainer}>
            <Form.Control
              as="textarea"
              style={styles.modalTextarea}
              value={fileContent}
              onChange={(e) => setFileContent(e.target.value)}
            />
            <div style={styles.buttonGroup}>
              <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                Скасувати
              </Button>
              <Button variant="primary" onClick={saveFileContent}>
                Зберегти
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Directory;